
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/application-development/done",
      function () {
        return require("private-next-pages/download/application-development/done/index.tsx");
      }
    ]);
  